import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdCalendarToday } from 'react-icons/md';
import { tidy_date, tidy_time_difference } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable';
import { duplicate_event, fetch_all_events } from '../../api/eventAPI';
import notify from '../../utils/IANotification';

export default function EventPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [eventData, setEventData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchEvents()
  }, [])

  const fetchEvents = async () => {
    setLoading(true)
    let { data, error, message } = await fetch_all_events()
    if (error) return console.error(error)
    setEventData(data)
    setLoading(false)
  }

  const duplicateEvents = async (event_id) => {
    let { data, error, message } = await duplicate_event({ event_id })
    if (error) return notify({ type: "error", message: "Failed to duplicate event" })
    fetchEvents()
    notify({ type: "success", message: "Event duplicated" })
  }

  const table_columns = [
    {
      header: "Event Name",
      accessor: "name"
    },
    {
      header: "Date & Time",
      accessor: "event_start_datetime",
      modifier: (data, row) => `${tidy_date(row?.event_start_datetime)} - ${tidy_date(row?.event_end_datetime)}`
    },
    {
      header: "Venue",
      accessor: "venue",
    },
    {
      header: "Status",
      accessor: "is_published",
      modifier: (data) => (data == "1" ? "Published" : "Draft"),
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data, row) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]

  return (
    <AdminLayout
      navSelected={"Events"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Events</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/events/details?event_id=new")
            }}
          >
            <MdAdd size={16} />
            New Event
          </button>
        </>
      }
    >



      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {
        loading ? (
          <div className="flex-row items-center flex justifyCenter w-100">
            <h1>Loading...</h1>
          </div>
        ) : (
          <div className="w-100">
            {/* {eventData.map((event, index) => {
              if (!JSON.stringify(event).toLowerCase().includes(query.toLowerCase())) return null
              return (
                <div
                  key={index}
                  className="flex-row items-center flex justify-between w-100 card mt-10"
                >
                  <div className="">
                    <h3>{event.name}</h3>
                    <h3 className='card-subtitle'>{tidy_date(event?.event_start_datetime)} • {event.venue}</h3>
                  </div>
                  <button
                    className="button"
                    onClick={() => {
                      navigate("/admin/events/details?event_id=" + event.id)
                    }}
                  >
                    View
                  </button>
                </div>
              )
            })} */}

            <DataTable
              columns={table_columns}
              data={eventData}
              enableActions
              actions={(row) => {
                return (
                  <div className="flex gap-2">
                    <button
                      className="hover:underline"
                      onClick={() => {
                        duplicateEvents(row.id)
                      }}
                    >
                      Duplicate
                    </button>
                    <button
                      className="hover:underline"
                      onClick={() => {
                        navigate("/admin/events/details?event_id=" + row.id)
                      }}
                    >
                      View
                    </button>
                  </div>
                )
              }}
            />
          </div>
        )
      }
    </AdminLayout >
  )
}
